import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30a44f5a")

_pushScopeId("data-v-30a44f5a")
const _hoisted_1 = { id: "home" }
const _hoisted_2 = { id: "landscaping" }
const _hoisted_3 = { class: "bg-white" }
const _hoisted_4 = {
  class: "container about-container",
  id: "introduction"
}
const _hoisted_5 = { class: "d-flex flex-column  justify-content-center align-items-center " }
const _hoisted_6 = {
  class: "container section-container",
  id: "service"
}
const _hoisted_7 = { class: "d-flex flex-column justify-content-center align-items-center " }
const _hoisted_8 = {
  class: "section-container mx-0 mb-0",
  id: "cases"
}
const _hoisted_9 = { class: "d-flex flex-column  justify-content-center align-items-center " }
const _hoisted_10 = {
  class: "container section-container",
  id: "faq"
}
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = {
  id: "footer",
  class: "d-flex flex-column"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LandscapingHeader = _resolveComponent("LandscapingHeader")
  const _component_LandscapingHero = _resolveComponent("LandscapingHero")
  const _component_LandscapingBar = _resolveComponent("LandscapingBar")
  const _component_LandscapingAboutUs = _resolveComponent("LandscapingAboutUs")
  const _component_LandscapingServiceArea = _resolveComponent("LandscapingServiceArea")
  const _component_LandscapingShowcase = _resolveComponent("LandscapingShowcase")
  const _component_LandscapingQuestion = _resolveComponent("LandscapingQuestion")
  const _component_LandscapingFooter = _resolveComponent("LandscapingFooter")
  const _component_LandscapingChatButton = _resolveComponent("LandscapingChatButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_LandscapingHeader, {
        ref: "toggleNav",
        data: $setup.gardenBasicData
      }, null, 8, ["data"]),
      _createVNode(_component_LandscapingHero),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_LandscapingBar, {
              class: "col-sm-4 ",
              title: _ctx.$t('homePage.introduction.title')
            }, null, 8, ["title"]),
            _createVNode(_component_LandscapingAboutUs, { basicData: $setup.gardenBasicData }, null, 8, ["basicData"])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_LandscapingBar, {
              class: "col-sm-4 ",
              title: _ctx.$t('homePage.service.title')
            }, null, 8, ["title"]),
            _createVNode(_component_LandscapingServiceArea, { serviceData: $setup.gardenServiceData }, null, 8, ["serviceData"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_LandscapingBar, {
              class: "col-sm-4 ",
              title: _ctx.$t('homePage.cases.title')
            }, null, 8, ["title"]),
            _createVNode(_component_LandscapingShowcase, { caseData: $setup.gardenCaseData }, null, 8, ["caseData"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_LandscapingBar, {
              class: "col-sm-4 align-self-center mb-5",
              title: _ctx.$t('homePage.faq.title')
            }, null, 8, ["title"]),
            _createVNode(_component_LandscapingQuestion, { questionData: $setup.gardenQuestionData }, null, 8, ["questionData"])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_LandscapingBar, {
            class: "col-sm-4 align-self-center",
            title: _ctx.$t('homePage.footer.title')
          }, null, 8, ["title"]),
          _createVNode(_component_LandscapingFooter)
        ]),
        _createVNode(_component_LandscapingChatButton)
      ])
    ])
  ]))
})